import { render, staticRenderFns } from "./Comp16t3.vue?vue&type=template&id=84dfced8&scoped=true&"
import script from "./Comp16t3.vue?vue&type=script&lang=js&"
export * from "./Comp16t3.vue?vue&type=script&lang=js&"
import style0 from "./Comp16t3.vue?vue&type=style&index=0&id=84dfced8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84dfced8",
  null
  
)

export default component.exports